import { RFile } from '../remote/upload';

enum StrapiUploadFileRef {
    Project = 'api::project.project',
    User = 'plugin::users-permissions.user',
    Post = 'api::post.post',
    Job = 'api::job.job',
    Institution = 'api::institution.institution'
}

enum StrapiUploadFileField {
    InstitutionLogo = 'logo',
    InstitutionMedia = 'media',
    ProfilePicture = 'profilePicture'
}

type FileUploadFormData = {
    // Strapi expects "files" with an S but it has to be type "File", not "File[]"
    // see https://docs.strapi.io/dev-docs/plugins/upload#upload-entry-files
    files: File | Blob;
    ref: StrapiUploadFileRef;
    refId: string; // e.g.: 'resultId'
    fileInfo?: string; // stringified Partial<RFile>
    field?: StrapiUploadFileField;
};

type InternalFile = RFile;

enum UploadType {
    Image = 'image',
    Document = 'document',
    Weblink = 'weblink'
}

type AllUploadTypes = UploadType.Image | UploadType.Document | UploadType.Weblink;

type UploadedMedia<T extends UploadType> = {
    id: number;
    documentId: string;
    // We need to create a unique id for this type on our own, because links and files can possibly have the same id.
    uniqueMediaId: string;
    type: T;
    name?: string;
    url: string;
    description?: string;
    source?: string;
    size?: number;
};

enum FileUploadError {
    FILE_SIZE = 'filesize_error',
    FILE_TYPE = 'filetype_error',
    IMAGE_ERROR = 'image_render_error',
    IMAGE_CROP = 'file_error',
    UPLOAD_ERROR = 'upload_error'
}

type FileToUpload = {
    id: number;
    name: string;
    data: Blob | File;
    description?: string;
    source?: string;
};

type LinkToUpload = {
    id: number;
    data: string;
    description?: string;
    source?: string;
};

type MediaToUpload = FileToUpload | LinkToUpload;

type MixedMedia = MediaToUpload | UploadedMedia<AllUploadTypes>;

export type {
    FileUploadFormData,
    InternalFile,
    UploadedMedia,
    FileToUpload,
    LinkToUpload,
    MediaToUpload,
    AllUploadTypes,
    MixedMedia
};

export { StrapiUploadFileRef, StrapiUploadFileField, UploadType, FileUploadError };
